import React from 'react';
import { AnchorProps } from '@sls-react/components/Links/A';
import { Link, useRouter } from '@sls-react/routing';
import { useModals } from '@sls-react/contexts/ModalsContext';
import qsStringify from '@sls-react/utils/qsStringify';
import { ModalProps } from '@sls-react/components/Modal/ModalsGroup';

interface RegisterLinkOptions {
  destination?: string;
  referralCode?: string;
  modalProps?: Partial<ModalProps<'loginRegister'>>;
}

type Props = AnchorProps & RegisterLinkOptions;

export function generateRegisterLink(options?: RegisterLinkOptions) {
  return `/register${qsStringify(options)}`;
}

export function generateRegisterOnboardingLink(options?: RegisterLinkOptions) {
  return `/register/onboarding${qsStringify(options)}`;
}

const RegisterLink: React.FC<Props> = ({ children, modalProps, ...props }) => {
  const router = useRouter();
  const modals = useModals();

  if (router.route === '/login' || router.route === '/register') {
    return (
      <Link href="/register">
        <a
          rel="nofollow noindex"
          aria-label="Sign up for SidelineSwap"
          {...props}
        >
          {children}
        </a>
      </Link>
    );
  }

  return (
    <a
      href="#"
      className={props.className}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        // props.onClick?.(e);
        modals.openModal('loginRegister', {
          defaultView: 'register',
          ...modalProps,
        });
      }}
      aria-label="Sign up for SidelineSwap"
    >
      {children}
    </a>
  );
};

export default RegisterLink;
